import React from 'react';
import { ctaHref, ctaIsExternal } from '../config/site';
interface CTAButtonProps {
  label: string;
  microcopy?: string;
  className?: string;
}
export function CTAButton({
  label,
  microcopy,
  className = ''
}: CTAButtonProps) {
  const href = ctaHref();
  const external = ctaIsExternal();
  return <div className={`relative z-20 w-full ${className}`} data-id="element-79" data-mp="2fzbr4a2vd417">
      <a href={href} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className="cta-button flex min-h-[58px] w-full items-center justify-center rounded-xl bg-cta px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white hover:bg-cta-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta sm:text-base" data-id="element-80" data-mp="2g1xzgbxl3nkh">
        {label}
      </a>
      {microcopy && <p className="mt-3 text-center text-xs text-ink/60 sm:text-sm" data-id="element-81" data-mp="3cnhvqwzsjwfh">{microcopy}</p>}
    </div>;
}